import { render, staticRenderFns } from "./RateiosEmMassa.vue?vue&type=template&id=5646f76d"
import script from "./RateiosEmMassa.vue?vue&type=script&lang=js"
export * from "./RateiosEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports